/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_FOLDER_COPY } from '@squiz/sds';
import { DashboardCardProps } from 'apps/console-core/src/Components/DashboardCard/DashboardCard.props';
import { screenPaths } from './ScreenPaths.constants';
import { DAM_STRINGS } from './Strings.constants';

export const FILE_STORE_DASHBOARD_CARD: DashboardCardProps = {
  description: DAM_STRINGS.fileStoreDescription,
  icon: ICON_FOLDER_COPY,
  link: screenPaths.fileStore,
  title: DAM_STRINGS.fileStore,
};

export const DAM_DASHBOARD_CARDS = [FILE_STORE_DASHBOARD_CARD];
